import { render, staticRenderFns } from "./myWorkbench.vue?vue&type=template&id=342f4020&scoped=true"
import script from "./myWorkbench.vue?vue&type=script&lang=js"
export * from "./myWorkbench.vue?vue&type=script&lang=js"
import style0 from "./myWorkbench.vue?vue&type=style&index=0&id=342f4020&prod&lang=css"
import style1 from "./myWorkbench.vue?vue&type=style&index=1&id=342f4020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342f4020",
  null
  
)

export default component.exports